import dayjsTZ from "../../../utils/dayjs";

/**
 * Resolve [start, end] dayjs bounds from year / quarter / month filters.
 * Default: current month.
 */
export function resolvePeriodRange({ year, quarter, month } = {}) {
  const y = year || dayjsTZ().year();
  if (month != null && month !== "") {
    const m = Number(month);
    const start = dayjsTZ().year(y).month(m).startOf("month");
    return [start, start.endOf("month")];
  }
  if (quarter != null && quarter !== "") {
    const q = Number(quarter);
    const startMonth = (q - 1) * 3;
    const start = dayjsTZ().year(y).month(startMonth).startOf("month");
    const end = start.add(2, "month").endOf("month");
    return [start, end];
  }
  const start = dayjsTZ().year(y).startOf("year");
  return [start, start.endOf("year")];
}

export function periodGrain({ month, quarter } = {}) {
  // Month → daily bars (richer charts); quarter/year → monthly.
  if (month != null && month !== "") return "day";
  if (quarter != null && quarter !== "") return "month";
  return "month";
}
